import { batch } from "solid-js";
import { ChannelUnread } from "../classes/ChannelUnread.js";
import { ClassCollection } from "./Collection.js";
/**
 * Collection of Channel Unreads
 */
export class ChannelUnreadCollection extends ClassCollection {
    /**
     * Load unread information from server
     */
    async sync() {
        const unreads = await this.client.api.get("/sync/unreads");
        batch(() => {
            this.reset();
            for (const unread of unreads) {
                this.getOrCreate(unread._id.channel, unread);
            }
        });
    }
    /**
     * Clear all unread data
     */
    reset() {
        this.updateUnderlyingObject({});
    }
    /**
     * Get or create
     * @param id Id
     * @param data Data
     */
    getOrCreate(id, data) {
        if (this.has(id)) {
            return this.get(id);
        }
        else {
            const instance = new ChannelUnread(this, id);
            this.create(id, "channelUnread", instance, this.client, data);
            return instance;
        }
    }
    /**
     * Get channel unread data for a specific Channel
     * @param channel Channel
     * @returns Unread
     */
    for(channel) {
        return this.getOrCreate(channel.id, {
            _id: {
                channel: channel.id,
                user: this.client.user.id,
            },
            last_id: null,
            mentions: [],
        });
    }
}
